import {Injectable, NgZone} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {v4 as uuidv4} from 'uuid';

@Injectable({
    providedIn: 'root',
})
export class StorageService {

    private storageSubjects: Map<string, BehaviorSubject<string | null>> = new Map();

    constructor(private zone: NgZone) {
        window.addEventListener('storage', (event: StorageEvent) => {
            if (event.key) {
                this.notifySubscribers(event.key, event.newValue);
            }
        });
    }

    private notifySubscribers(key: string, value: string | null): void {
        const subject = this.storageSubjects.get(key);
        if (subject) {
            this.zone.run(() => subject.next(value));
        }
    }

    setItem(key: string, value: string): void {
      localStorage.setItem(key, value);
        this.notifySubscribers(key, value);
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
        this.notifySubscribers(key, null);
    }

    getItem(key: string): any {
        return localStorage.getItem(key)
    }

  getOrStoreItem(key: string, fn: () => any): any {
    if (localStorage.getItem(key) === null) {
      if (fn) {
        const value = fn();
        this.setItem(key, value);
        return value;
      }
    }
    return this.getItem(key);
  }

    observeKey(key: string): Observable<string | null> {
        if (!this.storageSubjects.has(key)) {
            const initialValue = this.getItem(key);
            this.storageSubjects.set(key, new BehaviorSubject<string | null>(initialValue));
        }
        return this.storageSubjects.get(key)!.asObservable();
    }

  generateUUID(): string {
    return uuidv4();
  }

  generatePlatformFriendlyName(): string {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;

    let browser = 'Unknown';
    let version = 'Unknown';
    let os = platform;

    // Simple browser detection
    if (/chrome|crios|crmo/i.test(userAgent)) {
      browser = 'Chrome';
      const match = userAgent.match(/(?:chrome|crios|crmo)\/([0-9\.]+)/i);
      if (match) version = match[1];
    } else if (/firefox|fxios/i.test(userAgent)) {
      browser = 'Firefox';
      const match = userAgent.match(/(?:firefox|fxios)\/([0-9\.]+)/i);
      if (match) version = match[1];
    } else if (/safari/i.test(userAgent) && !/chrome|crios|crmo/i.test(userAgent)) {
      browser = 'Safari';
      const match = userAgent.match(/version\/([0-9\.]+)/i);
      if (match) version = match[1];
    } else if (/edg/i.test(userAgent)) {
      browser = 'Edge';
      const match = userAgent.match(/edg\/([0-9\.]+)/i);
      if (match) version = match[1];
    }

    return `${browser} ${version} ${os}`;

  }

}
